import React, { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { applyProgereTheme, getThemePreference } from "@/services/progereTheme";

// Bascule simple clair/sombre (utilisée sur les pages publiques) — délègue au service PROGÈRE.
export function ThemeToggle() {
  const [pref, setPref] = useState(() => (getThemePreference() === "light" ? "light" : "dark"));
  useEffect(() => { applyProgereTheme(pref); }, [pref]);
  return (
    <button onClick={() => setPref((p) => (p === "light" ? "dark" : "light"))} data-testid="theme-toggle"
      title={pref === "light" ? "Mode sombre" : "Mode clair"}
      className="text-gray-400 hover:text-[#F2BC2E] transition-colors">
      {pref === "light" ? <Moon size={18} /> : <Sun size={18} />}
    </button>
  );
}
